__turbopack_context__.v({
  "dot": "DevelopmentIndicator-module__7tslUa__dot",
  "label": "DevelopmentIndicator-module__7tslUa__label",
  "pill": "DevelopmentIndicator-module__7tslUa__pill",
});
